import { useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useAtom } from "@dbeining/react-atom";
import { userAtom } from "../../atoms";
import { useUserData, useUserActions } from "../../hooks";
import {
    UserActionButtons,
    UserInfoCard,
    UserProfileHeader,
    UserStatusAlert,
    ActionButtonsSkeleton
} from "../../components/ui/UserPage";
import {
    UserColorEdit,
    UserDisplayNameEdit,
    UserPasswordEdit,
    UserRoleEdit
} from "../../components";

const UserPage = () => {
    const { user, color, refreshUserData } = useUserData();
    const {
        updating,
        alertVariant,
        statusMessage,
        disableAndEndAllSessionsForUserWithId,
        enableUserWithId,
        resetLockedOutUserWithId,
        updateTwoFAIsRequired,
        resetTwoFactorSecretKey,
        clearStatusMessage
    } = useUserActions();
    
    const currentUser = useAtom(userAtom);
    
    const [showEditRoles, setShowEditRoles] = useState(false);
    const [showEditDisplayName, setShowEditDisplayName] = useState(false);
    const [showEditColor, setShowEditColor] = useState(false);
    const [showEditPassword, setShowEditPassword] = useState(false);

    const handleUserInteraction = () => {
        refreshUserData();
    };

    return (
        <Container fluid>
            <UserProfileHeader user={user} />

            <Row>
                {user && (
                    <UserActionButtons
                        user={user}
                        currentUserId={currentUser?.identity.id}
                        updating={updating}
                        onDisable={disableAndEndAllSessionsForUserWithId}
                        onEnable={enableUserWithId}
                        onUnlock={resetLockedOutUserWithId}
                        onUpdateTwoFA={updateTwoFAIsRequired}
                        onResetTwoFA={resetTwoFactorSecretKey}
                    />
                )}
                {!user && <ActionButtonsSkeleton />}
            </Row>

            <UserStatusAlert
                variant={alertVariant}
                message={statusMessage}
                onClose={clearStatusMessage}
            />

            <UserInfoCard
                user={user}
                color={color}
                onEditDisplayName={() => setShowEditDisplayName(true)}
                onEditColor={() => setShowEditColor(true)}
                onEditRoles={() => setShowEditRoles(true)}
                onEditPassword={() => setShowEditPassword(true)}
            />

            {user && (
                <>
                    <UserDisplayNameEdit
                        show={showEditDisplayName}
                        setShow={setShowEditDisplayName}
                        user={user}
                        setUserInteraction={handleUserInteraction}
                    />
                    <UserRoleEdit
                        show={showEditRoles}
                        setShow={setShowEditRoles}
                        user={user}
                        setUserInteraction={handleUserInteraction}
                    />
                    <UserColorEdit
                        show={showEditColor}
                        setShow={setShowEditColor}
                        user={user}
                        color={color}
                        setUserInteraction={handleUserInteraction}
                    />
                    <UserPasswordEdit
                        show={showEditPassword}
                        setShow={setShowEditPassword}
                        user={user}
                        setUserInteraction={handleUserInteraction}
                    />
                </>
            )}
        </Container>
    );
};

export { UserPage };
